import DynamicSettingsForm from '../DyanmicSettings/DynamicSettingsForm';
import LayoutHandler from '../Component/LayoutHandler';
import CommandActions from '../Component/CommandActions';

const PANEL_SETTINGS_SCHEMA = {
  'floodgate-type': {
    label: 'Floodgate Type',
    type: 'select',
    options: ['simple', 'custom'],
    required: true,
    hiddenIfTypeIs: ['inventory', 'dialog'],
  },
  subtitle: {
    label: 'Subtitle',
    type: 'string',
    required: false,
    hiddenIfTypeIs: ['inventory', 'dialog'],
  },
  title: {
    label: 'Title',
    type: 'string',
    required: true,
  },
  conditions: {
    label: 'Conditions',
    type: 'string',
    required: false,
  },
  command: {
    label: 'Command',
    type: 'string',
    required: false,
  },
  aliases: {
    label: 'Aliases',
    type: 'list',
    required: false,
  },
  rows: {
    label: 'Rows',
    type: 'string',
    required: false,
    hiddenIfTypeIs: ['floodgate', 'dialog'],
  },
  'inventory-lock': {
    label: 'Inventory Lock',
    type: 'boolean',
    required: false,
    hiddenIfTypeIs: ['floodgate', 'dialog'],
  },
  columns: {
    label: 'Columns',
    type: 'string',
    required: false,
    hiddenIfTypeIs: ['floodgate', 'inventory'],
  },
  'has-exit-button': {
    label: 'Has Exit Button',
    type: 'boolean',
    required: false,
    hiddenIfTypeIs: ['floodgate', 'inventory'],
  },
  'after-action': {
    label: 'After Action',
    type: 'string',
    required: false,
    hiddenIfTypeIs: ['floodgate', 'inventory'],
  },
  escapable: {
    label: 'Escapable',
    type: 'boolean',
    required: false,
    hiddenIfTypeIs: ['floodgate', 'inventory'],
  },
  'update-interval': {
    label: 'Update Interval',
    type: 'string',
    required: false,
    hiddenIfTypeIs: ['floodgate', 'dialog'],
  },
  floodgate: {
    label: 'Floodgate',
    type: 'string',
    required: false,
    hiddenIfTypeIs: ['floodgate'],
  },
};

export default function PanelSettings({ config, setConfig, selectedItem, setSelectedItem }) {
  const layout = config.layout || {};

  const handleSelectChange = (e) => {
    setSelectedItem(e.target.value);
  };

  // Build a single "settings" actions object from flat config
  const settingsActions = {
    ...(config.open ? { open: config.open } : {}),
    ...(config.close ? { close: config.close } : {}),
    ...(config.refresh ? { refresh: config.refresh } : {}),
    ...(config.outside ? { outside: config.outside } : {}),
  };

  // Adapter: take CommandActions' merged actions and sync back to flat config keys
  const setSettingsActions = (updated) => {
    const next = { ...config };

    // open
    if (updated.open === undefined) {
      delete next.open;
    } else {
      next.open = updated.open;
    }

    // close
    if (updated.close === undefined) {
      delete next.close;
    } else {
      next.close = updated.close;
    }

    // refresh
    if (updated.refresh === undefined) {
      delete next.refresh;
    } else {
      next.refresh = updated.refresh;
    }

    // outside
    if (updated.outside === undefined) {
      delete next.outside;
    } else {
      next.outside = updated.outside;
    }

    setConfig(next);
  };

  return (
    <>
      <h3 style={{ marginBottom: '1.5rem' }}>Panel Configuration</h3>
      <DynamicSettingsForm
        panelType={config.type}
        config={config}
        setConfig={setConfig}
        settingsSchema={PANEL_SETTINGS_SCHEMA}
        title="Panel Settings"
      />

      <h3 style={{ marginBlock: '1.5rem' }}>Layout Configuration</h3>
      <div className="panel-settings-container">

        {config?.items && Object.keys(config.items).length > 0 && selectedItem in config.items ? (
          <div>
            <h4>Selected Item</h4>
            <select
              style={{
                flexGrow: 1,
                width: '100%',
                marginLeft: 0,
                marginBottom: '1rem',
                padding: '6px 8px',
                fontSize: '14px',
                borderRadius: '4px',
                border: '1px solid #4b5563',
                background: '#1e2126',
                color: '#ffffff',
                fontFamily: 'inherit',
                transition: 'border-color 0.15s ease',
              }}
              value={selectedItem || ''}
              onChange={handleSelectChange}
              aria-label="Select item"
            >
              {Object.keys(config.items).map((itemKey) => (
                <option key={itemKey} value={itemKey}>{itemKey}</option>
              ))}
            </select>
          </div>
        ) : null}

        <LayoutHandler
          layout={layout}
          selectedItem={selectedItem}
          configType={config.type}
          onLayoutChange={(newLayout) => {
            const newConfig = { ...config };
            if (Object.keys(newLayout).length > 0) {
              newConfig.layout = newLayout;
            } else {
              delete newConfig.layout;
            }
            setConfig(newConfig);
          }}
        />

        {/* Unified settings actions */}
        <h3 style={{ marginBlock: '1.5rem' }}>Panel Commands</h3>
        <CommandActions
          panelType="settings"
          // Pass the parent panel type through itemType so CommandActions can decide availability.
          // This keeps CommandActions flat and re-usable elsewhere.
          itemType={config?.type}
          actions={settingsActions}
          setActions={setSettingsActions}
        />
      </div>
    </>
  );
}
